import { AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-angle-editor',
  templateUrl: './angle-editor.component.html',
  styleUrls: ['./angle-editor.component.scss']
})
export class AngleEditorComponent implements AfterViewInit {

  private _angle: number = 0;
  @Input()
  set angle(value:number) {
    if(value === this._angle) return;
    this._angle = value;
    this.angleChange.emit(this._angle);
  }
  get angle():number {
    return this._angle;
  }
  @Output()
  angleChange = new EventEmitter<number>();

  @Input()
  bearing: number = 0;

  @Output()
  bearingChange = new EventEmitter<number>();


  @Input()
  direction:'from' | 'to' = 'to';
  constructor() { }

  ngAfterViewInit(): void {
  }

  AngleChanged() {
    this.angleChange.emit(this.angle);
  }

}
